import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";

export const Footer: React.FC = () => {
  const { theme } = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className={`py-3 px-6 border-t text-sm flex items-center justify-between ${
        theme === "light"
          ? "bg-white border-gray-200 text-gray-500"
          : "bg-slate-900 border-slate-700 text-slate-400"
      }`}
    >
      <div />
      
      <div className="flex items-center gap-2">
        <span>© {currentYear} Metatalio. All rights reserved.</span>
        <span>|</span>
        <span>Version 1.0.0</span>
      </div>
      
      <div className="flex items-center gap-4">
        <Link
          to="/support"
          className={`hover:underline ${
            theme === "light" ? "hover:text-sky-600" : "hover:text-cyan-400"
          }`}
        >
          Support
        </Link>
        <Link
          to="/support"
          className={`hover:underline ${
            theme === "light" ? "hover:text-sky-600" : "hover:text-cyan-400"
          }`}
        >
          Documentation
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
